import React from 'react'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

const CentroCostoNivel1FormGroup = ({ centroCostoNivel1, setCentroCostoNivel1, index }) => {
  const oneRowTrigger = React.useCallback(
    primeraFila => {
      setCentroCostoNivel1(primeraFila._id)
    },
    [setCentroCostoNivel1]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <SelectCentroCosto
          id={`select-centroCostoNivel1-${index}`}
          name={`select-centroCostoNivel1-${index}`}
          onChange={e => setCentroCostoNivel1(e.target.value)}
          value={centroCostoNivel1}
          nivel={1}
          oneRowTrigger={oneRowTrigger}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
